import type { TranslationKey } from '@/i18n-key';

import { IMPORTANCE_LEVELS, type ImportanceLevel } from '@/types/career-growth';

const isImportanceLevel = (level: number): level is ImportanceLevel =>
    (IMPORTANCE_LEVELS as readonly number[]).includes(level);

/** Names an importance level, and falls back to "not assessed" for anything off the scale. */
export const importanceLevelKey = (level: number): TranslationKey =>
    isImportanceLevel(level)
        ? `performanceProfile.growth.aspiration.importanceLevels.${level}`
        : 'performanceProfile.growth.aspiration.importanceLevels.unknown';
